{
  "Announcements": "Annunci",
  "MarkAllAsRead": "Segna tutto come letto",
  "NoLinkNotification": "Nessun link disponibile per questa notifica",
  "Notification": "Notifiche",
  "ViewAll": "Visualizza tutto"
}
